import { componentsLibraryPrimitives as primitive } from '@rbilabs/components-library';

const BRAND = process.env.REACT_APP_RBI_BRAND as string;

export const brandFont = {
  headerOne: 'var(--font-headerOne)',
  headerTwo: 'var(--font-headerTwo)',
  headerThree: 'var(--font-headerThree)',
  headerFour: primitive[BRAND].$headerFour,
  copyOne: 'var(--font-copyOne)',
  copyTwo: primitive[BRAND].$copyTwo,
  formUtility: primitive[BRAND].$formUtility,
};
